import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { ApiRoutes } from "./Routes";
import ValidatedInput from "../common/ValidatedInput";
import FormWrap from "../common/FormWrap";
import formValidation from "../common/utils/formValidation";
import handleFileUpload from "../helpers/fileReader";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a;
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const handleSubmit = () => {
    var _a2;
    fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.WorkspaceV2.CHECK_CREDENTIALS), {
      service_account_key: ((_a2 = formData == null ? void 0 : formData.serviceAccountKey) == null ? void 0 : _a2.fileContent) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to Google Workspace using provided configuration."
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to Google Workspace using provided configuration."
      });
    });
  };
  const onFileUpload = (e) => {
    e.persist();
    handleFileUpload(e.target.files[0], (fileName, fileContent) => onChange(e, { fileName, fileContent }));
  };
  const accountKeyHelpText = ((_a = formData.serviceAccountKey) == null ? void 0 : _a.fileName) ? `Currently using file: ${formData.serviceAccountKey.fileName}.` : "Service account key JSON.";
  const isFormValid = formValidation.isFormValid(
    ["workspaceName", "serviceAccountKey", "workspaceDatasetName"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify & Proceed",
      disabled: isFormValid,
      title: "",
      className: "col-md-7",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "workspaceName",
        type: "text",
        fieldData: formData.workspaceName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "serviceAccountKey",
        type: "file",
        onChange: onFileUpload,
        fieldData: formData.serviceAccountKey,
        label: "Service Account Key",
        help: accountKeyHelpText,
        accept: ".json",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "workspaceDatasetName",
        type: "text",
        onChange,
        fieldData: formData.workspaceDatasetName,
        help: "The BigQuery Dataset Name where workspace events are exported.",
        label: "BigQuery Dataset Name",
        required: true
      }
    )
  );
};
export default StepAuthorize;
